module.exports = {
  "conn-con8": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variantA"
      ]
    }
  },
  "copy-con9": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variantA"
      ]
    }
  },
  "acad-0029": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variationA",
        "variationB",
        "variationC"
      ]
    }
  },
  "acad-0012": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  }
};